var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image',_vm._b({class:{'loading': _vm.loading},on:{"load":function($event){_vm.loading = false},"error":function($event){_vm.loading = false}}},'el-image',this.$props,false),[_c('span',{staticClass:"placeholder",attrs:{"slot":"placeholder"},slot:"placeholder"},[_vm._v("图片加载中...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-126bc92a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyImage.vue
// module id = null
// module chunks = 